import { render, staticRenderFns } from "./addScheduleSidebar.vue?vue&type=template&id=3c19e922&scoped=true&"
import script from "./addScheduleSidebar.vue?vue&type=script&lang=js&"
export * from "./addScheduleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addScheduleSidebar.vue?vue&type=style&index=0&id=3c19e922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19e922",
  null
  
)

export default component.exports